import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  headerTitle: {
    key: `ModalDocumentsTips-header-title`,
    defaultValue: 'Fontes de dados',
  },
  bodyFirstCardTitle: {
    key: `ModalDocumentsTips-body-first-card-title`,
    defaultValue: 'A Zai e seu workspace com mais contexto',
  },
  bodySecondCardTitle: {
    key: `ModalDocumentsTips-body-second-card-title`,
    defaultValue: 'Diversidade de formatos de arquivo',
  },
  bodyThirdCardTitle: {
    key: `ModalDocumentsTips-body-third-card-title`,
    defaultValue: 'Seus arquivos ficarão seguros com a gente',
  },

  bodyFirstCardBody: {
    key: `ModalDocumentsTips-body-first-card-body`,
    defaultValue:
      'Os documentos adicionados dão mais contexto à Zai em todo o workspace. A qualidade das respostas depende de arquivos corretos e atualizados, que podem ser excluídos se necessário.',
  },
  bodySecondCardBody: {
    key: `ModalDocumentsTips-body-second-card-body`,
    defaultValue:
      'É possível adicionar arquivos PDF, DOC, DOCX, CSV e TXT. Apresentações em PPT precisam ser exportadas para PDF para upload. O limite é de 100 MB por arquivo e 10 GB no total.',
  },
  bodyThirdCardBody: {
    key: `ModalDocumentsTips-body-third-card-body`,
    defaultValue:
      'Apenas os usuários que têm acesso ao seu workspace poderão consumir os documentos e eles ficarão completamente protegidos com a gente.',
  },
  footerTitle: {
    key: `ModalDocumentsTips-footer-title`,
    defaultValue: 'Expanda agora o conhecimento da Zai com documentos da sua marca',
  },
  footerAction: {
    key: `ModalDocumentsTips-footer-action`,
    defaultValue: 'Adicionar arquivos',
  },
})
